import React from 'react';
import QuestionWrapper from '../../ui/question_wrapper';
import QuestionHeading from '../../ui/question_heading';
import QuestionSubheading from '../../ui/question_subheading';
import CheckboxPillGroup from '../../ui/checkbox_pill_group';
import TextInput from '../../ui/text_input';

import { useQuestionnaireStep } from '../../../../wrappers/question_wrapper/step_context';

const CheckboxPillQuestion = ({
  heading,
  subHeading = 'Select all that apply',
  name,
  options,
  values,
  onToggle,
  onSubmit,
  submitDisabledWhenEmpty = true,
  current,
  total,
  onBack,
  ariaLabel,
  showNavButtons = true,
  showOther = false,
  otherValue = '',
  onOtherChange,
  otherPlaceholder = 'Other',
}) => {
  const step = useQuestionnaireStep();
  const resolvedCurrent = current ?? step.current;
  const resolvedTotal = total ?? step.total;
  const empty = !values || values.length === 0;
  const otherEmpty = !otherValue || otherValue.trim() === '';
  const isDisabled = submitDisabledWhenEmpty && empty && otherEmpty;

  const handleSubmit = () => {
    if (typeof onSubmit === 'function') onSubmit(values || [], otherValue || '');
  };

  return (
    <QuestionWrapper
      current={resolvedCurrent}
      total={resolvedTotal}
      onBack={onBack}
      onSubmit={handleSubmit}
      isDisabled={isDisabled}
      showNavButtons={showNavButtons}
    >
      <QuestionHeading>{heading}</QuestionHeading>
      {subHeading && <QuestionSubheading>{subHeading}</QuestionSubheading>}
      <CheckboxPillGroup
        name={name}
        options={options}
        values={values}
        onToggle={onToggle}
        ariaLabel={ariaLabel || heading}
      />
      {showOther && (
        <TextInput
          value={otherValue}
          onChange={onOtherChange}
          placeholder={otherPlaceholder}
          ariaLabel={otherPlaceholder}
        />
      )}
    </QuestionWrapper>
  );
};

export default CheckboxPillQuestion;
